/// <amd-module name="Repos/Tfvc/Common/Utils/Shelveset" />
import { encodeUri } from "VSS/Platform/Util/Linking";

/**
 * Gets the artifact for the specified shelveset.
 *
 * @param shelvesetName Name of the shelveset.
 * @param shelvesetOwner Owner of the shelveset.
 */
export function getArtifactUri(shelvesetName: string, shelvesetOwner: string): string {
    return encodeUri({
        id: `${encodeURIComponent(shelvesetName).replace(/%20/g, '+')}&shelvesetOwner=${encodeURIComponent(shelvesetOwner)}`,
        tool: "VersionControl",
        type: "Shelveset"
    });
}
